// assets/product-custom-property.js
import { Component } from '@theme/component';

/**
 * A custom element that manages product custom properties.
 */
class ProductCustomProperty extends Component {
  handleInput() {
    this.#updateCharacterCount();
  }

  #updateCharacterCount() {
    const { characterCount, textInput } = this.refs;
    const currentLength = textInput.value.length;
    const maxLength = textInput.maxLength;
    const template = characterCount.getAttribute('data-template');
    if (!template) return;

    characterCount.textContent = template.replace('[current]', currentLength.toString()).replace('[max]', maxLength.toString());
  }
}

customElements.define('product-custom-property-component', ProductCustomProperty);

const attachmentDescription =
  'Attach one photo, logo, or PDF reference for order context. Your product uses the selected standard breed artwork; attachments do not create a custom portrait or change markings or coloring.';
const mixedBreedDescription =
  'A reference attachment is required for Mixed Breed so we can confirm the artwork direction before production.';

function updateMixedBreedAttachmentRequirement(breedSelect) {
  const formId = breedSelect.getAttribute('form');
  if (!formId) return;

  const attachment = document.querySelector(`input[type="file"][name="properties[Attachment]"][form="${CSS.escape(formId)}"]`);
  if (!attachment) return;

  const attachmentComponent = attachment.closest('product-custom-property-component');
  const description = attachmentComponent?.querySelector('[data-attachment-description]');
  const isMixedBreed = breedSelect.value === 'Mixed Breed';

  attachment.required = isMixedBreed;
  attachment.setAttribute('aria-required', String(isMixedBreed));
  attachmentComponent?.classList.toggle('is-required-for-mixed-breed', isMixedBreed);

  if (description) {
    description.textContent = isMixedBreed
      ? `${attachmentDescription} ${mixedBreedDescription}`
      : `${attachmentDescription} Required for Mixed Breed; otherwise optional.`;
  }
}

function setUpMixedBreedAttachmentRequirement() {
  document.querySelectorAll('select[name="properties[Breed / art choice]"]').forEach((breedSelect) => {
    breedSelect.addEventListener('change', () => updateMixedBreedAttachmentRequirement(breedSelect));
    updateMixedBreedAttachmentRequirement(breedSelect);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setUpMixedBreedAttachmentRequirement, { once: true });
} else {
  setUpMixedBreedAttachmentRequirement();
}
